import { MatxLoadable } from "matx";
import { isMdScreen } from "utils";

const Newsletter = MatxLoadable({
    loader: () => import("./Newsletter")
});

const NewsletterAdminForm = MatxLoadable({
    loader: () => import("./forms/FormAdminNewsletter")
});

const NewsletterTable = MatxLoadable({
    loader: () => import("./tables/AdminNewsletterTable")
});

const settings = {
    activeLayout: "layout1",
    layout1Settings: {
    topbar: {
        show: true
    },
    leftSidebar: {
        show: true,
        mode: isMdScreen() ? "close" : "full"
    }
    },
    likeDislikeButtons: { show: false }
};

const NewsletterRoutes = [
    {
    path: "/newsletters/home",
    component: Newsletter,
    },
    {
        path: "/newsletters/form/:id",
        component: NewsletterAdminForm,
    },
    {
        path: "/newsletters/form",
        component: NewsletterAdminForm,
    },
    {
        path: "/newsletters/list",
        component: NewsletterTable,
    },
];

export default NewsletterRoutes;